import { useTranslation } from 'react-i18next';
import useRouteBasedStepperLayout from 'components/Stepper/RouteBasedStepper/useRouteBasedStepperLayout';
import { portfolioSelector, usePortfolioSelector } from 'domain/Portfolio';
import { useMemo } from 'react';
import { useContactGroupOwners } from 'hooks/helpers/useContactGroupOwners';
import useChangeWithdrawalFlow from './useChangeWithdrawalFlow';

export const useChangeWithdrawalPlanLayout = () => {
    const { t } = useTranslation();
    const { stepsBasedOnState } = useChangeWithdrawalFlow();
    const { dataRaw: portfolio } = usePortfolioSelector(portfolioSelector);
    const { mainOwner, jaClient } = useContactGroupOwners({ connectionGroupId: portfolio?.ContactGroupId });

    const footerAdditionalInfo = useMemo(() => [
        {
            label: 'portfolio.createNewPortfolio.clientName',
            values: [mainOwner?.name ?? '-', ...[jaClient?.name]],
        },
        {
            label: 'portfolio.createNewPortfolio.clientAge',
            values: [mainOwner?.age?.toString() ?? '-', ...[jaClient?.age?.toString()]],
        },
    ], [mainOwner, jaClient]);

    const {
        stepper: {
            steps: currentProcessSteps,
            title,
            currentStepNumber,
        },
        contentTitle,
        contentClassName,
        isStepperEnabled,
        isFooterSimplified,
        onContinue,
        onBack,
        continueDisabled,
        isContinueLoading,
        backDisabled,
        hideStepperButtons,
        productType,
    } = useRouteBasedStepperLayout({
        title: t('portfolio.createNewPortfolio.withdrawalPlan'),
        productType: portfolio?.Name,
        stepsBasedOnState,
    });

    return {
        footerAdditionalInfo,
        stepper: {
            steps: currentProcessSteps,
            title,
            currentStepNumber,
        },
        onBack,
        onContinue,
        continueLabel: 'Continue',
        continueDisabled,
        backLabel: 'Back',
        backDisabled,
        inProgress: isContinueLoading,
        isStepperEnabled,
        isFooterSimplified,
        contentTitle,
        contentClassName,
        hideStepperButtons,
        productType,
        startDate: null,
        minStartDate: null,
    };
};
